import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]
  connect() {
    this.opened = false;

    this.fieldTargets.forEach((element) => {
      element.mouseOn = false;

      element.onmouseover = () => {
        element.mouseOn = true;
      };

      element.onmouseleave = () => {
        element.mouseOn = false;
      };
    });

    this._keydownHandler = (event) => {
      const activeElement = this.fieldTargets.find(el => el.mouseOn);

      if (activeElement) {
        if (event.code === "KeyO") this.open(activeElement);
        if (event.code === "KeyC") this.close(activeElement);
      }
    };

    document.addEventListener('keydown', this._keydownHandler);

    const that = this;

    document.getElementById("header").addEventListener('click', function (evt) {
      that.handleHeaderClick(evt)
    })
  }


  handleHeaderClick(event) {
    if (event.detail !== 3) return

    this.opened = !this.opened
    this.fieldTargets.forEach(element => {
      this.opened ? this.open(element) : this.close(element)
    })
  }

  open(el){
   el.classList.remove("blur-md");
  }

  close(el){
    el.classList.add("blur-md");
  }
}